import React from "react";
import "./mural-hotspots.css";
import { Utils } from "../../js/utils";

class MuralHotspots extends React.Component {
  constructor(props) {
    super(props);
    this.currentModel = null;
  }

  render() {
    const bgPath = this.props.mode == 'kiosk' ? this.props.kioskbackground : this.props.background;
    const bg = {path: bgPath, type: Utils.getMediaType(bgPath)};
    return (
      <div id="muralHotspots" style={{backgroundImage: this.props.posterPath ? 'url(' + this.props.posterPath + ')' : 'none'}}>
        {bg.type == 'vid' ? <video id="bgVideo" className="bg" src={bg.path} playsInline autoPlay loop muted disablePictureInPicture />
        : <img className="bg" src={bg.path} />}
        
        {this.props.mode == 'kiosk' && <div id="hotspotContainer">
          {this.props.hotspots.map(hs => {
            let hsClass = 'hotspot ' + (hs.id === this.props.activeId ? ' active' : '') + (hs.filter.some(el => this.props.filter.includes(el)) ? '' : ' hide');

            return <div
              key={hs.id}
              className={hsClass}
              onClick={e => !/subhotspot/.test(e.target.className) && this.props.openHS(hs.id)}>
              <div className="border-bg">
                <img className="thumb" src={hs.thumb} />
              </div>
              <label>{hs.name}</label>
              {/*hs.id === this.props.activeId && */
                <ul className={`subhotspots ${hs.id !== this.props.activeId ? 'hide' : ''}`}>
                {(hs.subhotspots || []).map(shs => <li
                  key={shs.id}
                  className={`subhotspot ${shs.id === this.props.activeId ? 'active' : ''}`}
                  onClick={e => this.props.openHS(shs.id)}>{shs.name}</li>)}
                </ul>}
            </div>
          })}
        </div>}

        {this.props.mode != 'kiosk' && this.props.background && this.props.hotspots.map(hs => {
          let position = { top: (hs.top * 100) + '%', left: (hs.left * 100) + '%', position: 'absolute' }
          let hsClass = 'hotspot ' + (hs.name.length <= 8 ? 'short' : hs.name.length <= 25 ? 'medium' : hs.name.length <= 36 ? 'long' : 'longer') + (hs.id === this.props.activeId ? ' active' : '') + (hs.filter.some(el => this.props.filter.includes(el)) ? '' : ' hide');

          return <div
            key={hs.id}
            style={position}
            onClick={e => !/subhotspot/.test(e.target.className) && this.props.openHS(hs.id)}>
              <div className={hsClass}>{hs.name}</div>
              {this.props.mode != 'wall' && hs.id === this.props.activeId && 
                <ul className={"subhotspots " + (hs.filter.some(el => this.props.filter.includes(el)) ? '' : ' hide')}>
                {(hs.subhotspots || []).map(shs => <li
                  key={shs.id}
                  className={`subhotspot ${shs.id === this.props.activeId ? 'active' : ''}`}
                  onClick={e => this.props.openHS(shs.id)}>{shs.name}</li>)}
                </ul>}
          </div>
        })}
      </div>
    );
  }
}

export default MuralHotspots;
